import React from 'react';
import { Modal, Button, Icon } from 'antd';
import { Container, ModalBody } from '../../components/Modals/styles';
import { DeleteIcon } from '../../images/svgIcons';
import { withTranslation } from 'react-i18next';
import { CONFIRMATION_MODAL } from '../../containers/GeneratedDocuments/translationValues';
/* This component contains the confirmation options to confirm before deleting the documents
  Child Components: 
    ************************
*/

const NAMESPACES = ['CONFIRMATION_MODAL'];

const ConfirmationModal = ({
  showImage = true,
  visibility,
  onConfirm,
  onCancel,
  confirmationText,
  confirmButtonText,
  isLoading,
  t
}) => {
  return (
    <Container visibility={visibility.toString()} onKeyDown={e => e.stopPropagation()}>
      <Modal
        title=""
        centered
        closable={false}
        visible={visibility}
        width="625px"
        onCancel={onCancel}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={onCancel} className="cancel">
            {t(
              CONFIRMATION_MODAL.CONFIRMATION_MODAL_CANCEL_BUTTON.key,
              CONFIRMATION_MODAL.CONFIRMATION_MODAL_CANCEL_BUTTON.value,
            )}
          </Button>,
          <Button
            key="submit"
            type="primary"
            className="delete"
            onClick={onConfirm}
            loading={isLoading}
          >
            {confirmButtonText}
          </Button>,
        ]}
        className="deleteConfirm-modal"
      >
        <ModalBody>
          <div className="delete-warning-text">
            {showImage && (
              <div className="deleteIcon">
                <Icon component={DeleteIcon} />
                <Icon style={{ color: '#f5222d' }} type="warning" />
              </div>
            )}
            <span style={{display: "flex", textAlign: "center"}}>{confirmationText}</span>
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default withTranslation(NAMESPACES)(ConfirmationModal);
